import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types';
import {Step, Stepper, StepLabel} from 'material-ui/Stepper';
import Divider from 'material-ui/Divider';
import RaisedButton from 'material-ui/RaisedButton';
import FlatButton from 'material-ui/FlatButton';
import {Switch, Route } from 'react-router-dom';
import {Card, CardTitle, CardText} from 'material-ui/Card';

import CerseActions from '../../actions/CerseActions';

import Step1 from './Step1';
import Step2 from './Step2';
import Step3 from './Step3';
import Step4 from './Step4';
import Step5 from './Step5';

class Page extends Component {
  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  state = {
    stepIndex: 0
  };

  componentDidMount() {
    CerseActions.loadFileCsv();
  }

  handleNext = () => {
    const {stepIndex} = this.state;
    this.setState({
      stepIndex: stepIndex + 1,
    });
    this.setHistory(stepIndex + 1);
  };

  handlePrev = () => {
    const {stepIndex} = this.state;
    if (stepIndex > 0) {
      this.setState({stepIndex: stepIndex - 1});
      this.setHistory(stepIndex - 1);
    }
  };

  setHistory(stepIndex) {
    this.context.router.history.push("/cerse/step/" + stepIndex);
  }

  componentWillMount() {
    //this.setHistory(0);
  }

  render() {

    const {stepIndex} = this.state;
    const contentStyle = {margin: '0 16px'};
    const paragraphStyle = {lineHeight: 1.5};
    const img34Style = {marginBottom: -6};

    return (
      <div style={{width: '100%', margin: 'auto'}}>
        {this.state.stepIndex > 0 &&
        <Stepper activeStep={stepIndex-1}>
          <Step>
            <StepLabel>
              <Link to="/cerse/step/1" onClick={() => {this.setState({stepIndex:1});}}>Research Project</Link>
            </StepLabel>
          </Step>
          <Step>
            <StepLabel>
              <Link to="/cerse/step/2" onClick={() => {this.setState({stepIndex:2});}}>Research Units</Link>
            </StepLabel>
          </Step>
          <Step>
            <StepLabel>
              <Link to="/cerse/step/3" onClick={() => {this.setState({stepIndex:3});}}>Identify the Guidance</Link>
            </StepLabel>
          </Step>
          <Step>
            <StepLabel>
              <Link to="/cerse/step/4" onClick={() => {this.setState({stepIndex:4});}}>Export References</Link>
            </StepLabel>
          </Step>
          <Step>
            <StepLabel>
              <Link to="/cerse/step/5" onClick={() => {this.setState({stepIndex:5});}}>Moving Forward</Link>
            </StepLabel>
          </Step>
        </Stepper>
        }

        <div style={contentStyle}>

          {this.state.stepIndex < 1 &&

          <Card style={{width: '100%', margin: 'auto'}}>
            <CardTitle title="CERSE" subtitle="A Catalog for Empirical Research in Software Engineering" />
            <CardText style={paragraphStyle}>
              <p>This tool aim to support researchers in identifying and selecting guidelines and other supporting literature (i.e. assessment instruments and knowledge organization systems) suitable for their research.</p>
              <p>We propose the strategy illustrated in figure below to use effectively the tool for guideline selection. Each step requires specific actions and can be linked to particular literature. The initial steps (i.e. 1 and 2) are addressed by related work, whereas the intermediate steps (3 and 4) are supported by our own catalog.</p>
              <p><strong>Novice researchers</strong> are encourage to follow the five-steps strategy, making use of supporting references listed in the right side of the Figure 5 to design a research proposal. <strong>More experienced researchers</strong> (i.e. already used to the initial steps) would most likely only benefit from steps 3 and 4.</p>
              <Divider />
              <div style={{width: '772', margin: 'auto'}}>
                <Link to="/cerse/step/1" onClick={() => {this.setState({stepIndex:1});}}><img src="/img/heuristics1.png" alt="" /></Link>
                <Link to="/cerse/step/2" onClick={() => {this.setState({stepIndex:2});}}><img src="/img/heuristics2.png" alt="" /></Link>
                <Link to="/cerse/step/3" onClick={() => {this.setState({stepIndex:3});}}><img src="/img/heuristics3.png" style={img34Style} alt="" /></Link>
                <Link to="/cerse/step/4" onClick={() => {this.setState({stepIndex:4});}}><img src="/img/heuristics4.png" alt="" /></Link>
                <Link to="/cerse/step/5" onClick={() => {this.setState({stepIndex:5});}}><img src="/img/heuristics5.png" alt="" /></Link>
              </div>
            </CardText>
          </Card>
          }

          <Switch>
            <Route path="/cerse/step/1" component={Step1} />
            <Route path="/cerse/step/2" component={Step2} />
            <Route path="/cerse/step/3" component={Step3} />
            <Route path="/cerse/step/4" component={Step4} />
            <Route path="/cerse/step/5" component={Step5} />
          </Switch>

          {this.state.stepIndex > 0 &&
          <div style={{marginTop: 12}}>
            <FlatButton
              label="Back"
              disabled={stepIndex < 1}
              onTouchTap={this.handlePrev}
              style={{marginRight: 12, zIndex: '0'}}
            />
            <RaisedButton
              label={stepIndex === 4 ? 'Finish' : 'Next'}
              disabled={stepIndex === 5}
              primary={true}
              onTouchTap={this.handleNext}
              buttonStyle={{zIndex: '0'}}
            />
          </div>
          }
        </div>
      </div>
    );
  }
}

export default Page;



// WEBPACK FOOTER //
// ./src/components/Cerse/index.js